<template>
  <div :class="['base-tile-background', `base-tile-background--${type}`]">
    <button
      class="base-tile"
      :aria-label="tileLabel"
      :class="{ active: isActive }"
      @click="clickHandler"
    >
      <div :class="['image-container', `image-container--${type}`]">
        <img
          v-if="isString(image)"
          :src="image"
          :alt="text"
          :class="`image-container--${type}__img`"
        />
        <component
          :is="image"
          v-else
          :class="`image-container--${type}__img`"
        />
      </div>
      <p
        :class="['base-tile__description', `base-tile__description--${type}`]"
        :style="{ textAlign }"
      >
        {{ text }}
      </p>
      <check-img class="base-tile__check" :class="{ visible: isActive }" />
    </button>
  </div>
</template>

<script>
import CheckImg from "@/assets/images/selected.svg";
import { isString } from "@/utils";

export default {
  name: "BaseTile",
  components: {
    CheckImg
  },
  props: {
    id: {
      type: [Number, String],
      required: true
    },
    image: {
      type: [Object, String],
      default: ""
    },
    text: {
      type: String,
      default: "Insert text"
    },
    textAlign: {
      type: String,
      default: "left"
    },
    type: {
      type: String,
      default: "model"
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    tileLabel() {
      return this.isActive
        ? this.$t("shared.uncheck-option")
        : this.$t("shared.check-option");
    }
  },
  methods: {
    clickHandler() {
      const action = this.isActive
        ? this.$t("shared.remove")
        : this.$t("shared.add");
      this.$emit("store-update", { action, id: this.id });
    },
    isString
  }
};
</script>

<style scoped lang="scss">
.base-tile-background {
  background-color: $color-white;
  border-bottom: 1px solid $color-grey-100;
  border-right: 1px solid $color-grey-100;
  flex-basis: 50%;
  box-sizing: border-box;
}

.base-tile {
  @include sizing(100%);

  opacity: .5;
  position: relative;
  padding-top: 10px;

  &:hover {
    opacity: 1;
  }

  &.active {
    background-color: $color-blue-100;
    opacity: 1;
  }

  .image-container {
    display: flex;
    justify-content: center;

    &--model {
      align-items: flex-end;

      &__img {
        box-sizing: border-box;
        max-width: 220px;
        width: 100%;
        padding-bottom: 3px;
      }
    }

    &--icon {
      padding: 20px 0 16px 0;
      align-items: center;

      &__img {
        max-height: 40px;
      }
    }
  }

  &__description {
    margin: 0 0 10px 0;
    padding: 0 20px;
    color: $color-black;

    &--icon {
      margin-bottom: 25px;
    }
  }

  &__check {
    @include sizing(20px);
    @include absolute(top 20px right 20px);

    display: none;

    &.visible {
      display: block;
    }
  }
}

@media screen and (min-width: $media-m) {
  .base-tile-background {
    @include flex-basis(33.3%);

    &--icon {
      @include flex-basis(50%);

      width: $icon-tile-size-l;
    }
  }
}

@media screen and (min-width: $media-l) {
  .base-tile-background {
    @include flex-basis(16.66%);

    &--icon {
      width: $icon-tile-size-m;
      flex-basis: auto;
    }

    .image-container--model__img {
      padding: 5px 15px;
    }
  }
}

@media screen and (min-width: $media-l),
  (-ms-high-contrast: active),
  (-ms-high-contrast: none) {
  .base-tile-background--icon {
    max-width: none;
  }
}

@media screen and (min-width: $media-xl) {
  .base-tile-background--icon {
    width: $icon-tile-size-m;
  }
}

@media screen and (min-width: $media-xxl) {
  .base-tile__description--model {
    margin-bottom: 20px;
  }

  .base-tile-background--icon {
    width: $icon-tile-size-l;
  }
}

@media screen and (min-width: $media-xxxl) {
  .base-tile-background:not(.base-tile-background--icon) {
    @include flex-basis(11.11%);
  }
}
</style>
